import { Box, Button, Grid, IconButton, Typography } from '@material-ui/core';
import React from 'react';
import { useFieldArray } from 'react-hook-form';
import SelectFieldCustom from '../ui/SelectFieldCustom';
import { TextFieldCustom } from '../ui/TextFieldCustom';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@material-ui/icons/Delete';

export const FormLiabilities = ({ indexApp, data }) => {
    const { t } = useTranslation();
    const {
        fields: liabilitiesFields,
        append: liabilitiesAppend,
        remove: liabilitiesRemove
    } = useFieldArray({
        name: `applicants[${indexApp}].liabilities`
    });

    const liabilitytype = t('los:liabilitytype', { returnObjects: true });

    return (
        <>
            <Typography component="div">
                <Box fontWeight="fontWeightMedium" pb={2} color="primary.main">
                    {indexApp === 0
                        ? t('employerLabels.titleLiability')
                        : t('employerLabels.titleLiability2')}
                </Box>
            </Typography>
            {liabilitiesFields.map((liability, indexLib) => {
                return (
                    <div key={liability.id}>
                        <Grid container spacing={3}>
                            <Grid item md={5} xs={12}>
                                <SelectFieldCustom
                                    name={`applicants[${indexApp}].liabilities[${indexLib}].type`}
                                    label={t('liabilityLabels.liabilitySource')}
                                    items={liabilitytype}
                                    defaultValue={liability.type}
                                />
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <TextFieldCustom
                                    name={`applicants[${indexApp}].liabilities[${indexLib}].balance`}
                                    label={t('liabilityLabels.balance')}
                                    money="true"
                                    defaultValue={liability.balance}
                                />
                            </Grid>
                            <Grid item md={3} xs={12}>
                                <TextFieldCustom
                                    name={`applicants[${indexApp}].liabilities[${indexLib}].payment`}
                                    label={t('liabilityLabels.payment')}
                                    money="true"
                                    defaultValue={liability.payment}
                                />
                            </Grid>
                            {/* {indexLib > 0 ? ( */}
                            <Grid item md={1}>
                                <IconButton
                                    aria-label="delete"
                                    size="medium"
                                    onClick={() => {
                                        liabilitiesRemove(indexLib);
                                    }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                            {/* ) : null} */}
                        </Grid>
                    </div>
                );
            })}
            <br />
            <Button
                size="small"
                variant="contained"
                disableElevation
                onClick={() => {
                    liabilitiesAppend({ type: '', value: '' });
                }}>
                {t('liabilityLabels.addLiability')}
            </Button>
        </>
    );
};
